import React from "react";
import Promo from "../component/Promo";

const PromoContainer = () => {
    return(
        <div id="promo">
            <Promo/>
        </div>
    );
}

export default PromoContainer;